import { getPrecision } from './get-precision';

// based on http://phrogz.net/round-to-nearest-via-modulus-division

/**
 * @name roundToNearest
 *
 * @description rounds a value to the nearest multiple of X
 *
 * @example
 * import { roundToNearest } from '@workbench/core';
 *
 * roundToNearest(6.369, 0.01); // '6.37'
 * roundToNearest(6.369, 0.05); // '6.4'
 * roundToNearest(6.3, 1); // '6'
 * roundToNearest(6.3, 5); // '5'
 * roundToNearest(7.7, 5); // '10'
 * roundToNearest(6.3, 100); // '0'
 * roundToNearest(1.100010, 0.001); // '1.1'
 */
export const roundToNearest = (value: number, multipleOf: number): string => {
  const half = multipleOf / 2;
  const result = value + half - ((value + half) % multipleOf);
  const withPrecision = result.toFixed(getPrecision(value));
  return String(parseFloat(withPrecision));
};
